// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2LF20","productName":"Table_productName__3_se7"};